import DetailsSection from "./details";
export default DetailsSection;